































import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
import UiTag from '@/components/Ui/Tag/Tag.vue'

export default Vue.extend({
  name: 'RatingColumn',
  props: {
    row: Object as () => Mailing
  },
  components: {
    UiTag
  },
  computed: {
    rating () {
      return this.row.getRating();
    },
    yesno () {
      return this.row.getYesNo();
    },
    likes () {
      return this.row.getLikes();
    }
  }
})
